import React from 'react';
import '../App.css';

class ContactPage extends React.Component 
{
	state = {
		
		firstName: "",
		lastName: "",
		email: "",
		subject: "",
		message: "",

		validFirstName: false,
		validLastName: false,
		validEmail: false,
		validSubject: false,
		validMessage: false,

	}

	sendEmail = () =>
	{
		console.log("Try send email");

		var valid =
			this.state.validFirstName &&
			this.state.validLastName &&
			this.state.validEmail &&
			this.state.validSubject &&
			this.state.validMessage;

		const serviceId = "service_dqdu9i6";
		const templateId = "template_f0xllzl";
		const variables = {
			subject: this.state.subject,
			first_name: this.state.firstName,
			last_name: this.state.lastName,
			from_email: this.state.email,
			message: this.state.message,
		}

		if (valid)
		{
			window.emailjs.send(
				serviceId,
				templateId,
				variables
			).then(res =>
			{
				alert("Message successfully sent!");
				this.resetFields();

			}).catch(err =>
			{
				alert("Sorry, there seems to be an error! Try sending an email to ramon.luisking14@gmail.com directly instead.");
			})

		}
	} 

	resetFields = () =>
	{
		var stateCopy = this.state;

		stateCopy.firstName = "";
		stateCopy.lastName = "";
		stateCopy.email = "";
		stateCopy.subject = "";
		stateCopy.message = "";

		stateCopy.validFirstName = false;
		stateCopy.validLastName = false;
		stateCopy.validEmail = false;
		stateCopy.validSubject = false;
		stateCopy.validMessage = false;

		this.setState({
			...stateCopy
		})
	}

	stringIsEmpty = (value) =>
	{
		return value === null || value === "";
	}

	handleFirstNameChange = (event) =>
	{
		var stateCopy = this.state;

		stateCopy.firstName = event.target.value;
		stateCopy.validFirstName =
			this.stringIsEmpty(event.target.value) ?
				false : true;
			
		this.setState({
			...stateCopy
		})
	}

	handleLastNameChange = (event) =>
	{
		var stateCopy = this.state;

		stateCopy.lastName = event.target.value;
		stateCopy.validLastName =
			this.stringIsEmpty(event.target.value) ?
				false : true;
		
		this.setState({
			...stateCopy
		})
	}

	handleEmailChange = (event) =>
	{
		var stateCopy = this.state;

		var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
		var isValid =
			!this.stringIsEmpty(event.target.value) &&
			pattern.test(event.target.value);

		stateCopy.email = event.target.value;
		stateCopy.validEmail = isValid;
		
		this.setState({
			...stateCopy
		})
	}

	handleSubjectChange = (event) =>
	{
		var stateCopy = this.state;

		stateCopy.subject = event.target.value;
		stateCopy.validSubject =
			this.stringIsEmpty(event.target.value) ?
				false : true;
		
		this.setState({
			...stateCopy
		})
	}

	handleMessageChange = (event) =>
	{
		var stateCopy = this.state;

		stateCopy.message = event.target.value;
		stateCopy.validMessage =
			this.stringIsEmpty(event.target.value) ?
				false : true;

		this.setState({
			...stateCopy
		})
	}

	renderContactField = (onChangeFunc, extraClassName, label, type, name, value, valid, error) =>
	{
		var errorClass =
			valid ?
			"contact-field-error-hidden" :
			"contact-field-error-shown";

		return (

			<div className={'contact-field ' + extraClassName}>

				<label className='contact-label'>
					{label}
				</label>
				<input
					onChange={onChangeFunc}
					className='contact-input'
					type={type}
					name={name}
					value={value}
				/>
				<p
					className={'contact-field-error ' + errorClass}
				>
					{error}
				</p>

			</div>

		);
	}

	render()
	{
		const messageErrorClass =
			this.state.validMessage ? 
			"contact-field-error-hidden" :
			"contact-field-error-shown";

		return (

			<div className='page contact-page'>

				<div className='section contact-section'>

					<div className='section-header'>

						Contact Me
	
					</div>

					<form className='contact-form'>

						{this.renderContactField(
							this.handleFirstNameChange,
							'contact-first-name',
							'First Name',
							'text',
							'first-name',
							this.state.firstName,
							this.state.validFirstName,
							'Enter your first name'
						)}

						{this.renderContactField(
							this.handleLastNameChange,
							'contact-last-name',
							'Last Name',
							'text',
							'last-name',
							this.state.lastName,
							this.state.validLastName,
							'Enter your last name'
						)}

						{this.renderContactField(
							this.handleEmailChange,
							'contact-email',
							'Email Address',
							'text',
							'email',
							this.state.email,
							this.state.validEmail,
							'Enter valid email'
						)}

						{this.renderContactField(
							this.handleSubjectChange,
							'contact-subject',
							'Subject',
							'text',
							'subject',
							this.state.subject,
							this.state.validSubject,
							'Enter a subject'
						)}

						<div className='contact-field contact-message'>

							<label className='contact-label'>
								Message
							</label>
							<textarea
								onChange={this.handleMessageChange} 
								className='contact-input contact-message-input'
								value={this.state.message}
								type='text'
								rows='10'
							>
							</textarea>
							<p
								className={'contact-field-error ' + messageErrorClass}
							>
								Enter your message
							</p>

						</div>

						<div className='contact-field contact-submit-container'>

							<div
								onClick={this.sendEmail.bind(this)}
								className='contact-submit'
							>
								Submit
							</div>

						</div>

					</form>

				</div>

			</div>

		);
	}
}

export default ContactPage;